import { Box, Stack } from '@mui/material';
import { Typography } from '@idu-nightlife/ui-kit';
import React from 'react';

type StandardPageLayoutProps = {
  title: string;
  children: React.ReactNode;
  actions?: React.ReactNode;
};

export const StandardPageLayout = ({ children, title, actions }: StandardPageLayoutProps) => {
  return (
    <Stack
      sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}
      direction="column"
      spacing={1}
    >
      <Stack direction="row" sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography.PageTitle gutterBottom>{title}</Typography.PageTitle>
        <Box>{actions}</Box>
      </Stack>

      <Box
        sx={{
          p: 3,
          flexGrow: 1,
          borderRadius: 1,
          display: 'flex',
          flexDirection: 'column',
          bgcolor: 'background.paper',
        }}
      >
        {children}
      </Box>
    </Stack>
  );
};
